<template>
  <div id="app" v-if="webConfigue">
    <Top />
    <router-view class="cm_router_container"> </router-view>
    <Bottom />
  </div>
</template>

<script>
import Top from "@/components/common/Top";
import Bottom from "@/components/common/Bottom";

export default {
  name: "app",
  components: {
    Top,
    Bottom,
  },
  data() {
    return {
      webConfigue:JSON.parse(window.localStorage.getItem("webConfigue"))
    };
  },
  methods: {
    getWebData() {
      this.$http({
        url: this.$http.adornUrl(
          "requestMainMobile/pageService/getWebConfigure"
        ),
        method: "post",
        data: {},
      }).then(({ data }) => {
        if (data.data != "" && data.data != undefined && data.data != null) {
          this.webConfigue = data.data;
          // for(let i=0;i<this.$store.state.comData.navList.length;i++){
          //   for(let j=0;j<webConfigue.length;j++){
          //     if(webConfigue[j][this.$store.state.comData.navList[i].alias]!=""&&webConfigue[j][this.$store.state.comData.navList[i].alias]!=undefined&&webConfigue[j][this.$store.state.comData.navList[i].alias]!=null){
          //       this.webData[i] = true
          //     }
          //   }
          // }
          // console.log(this.webData)
          window.localStorage.setItem(
            "webConfigue",
            JSON.stringify(this.webConfigue)
          );
        }
      });
    },
  },
  created(){
    this.getWebData();
  },
  mounted() {
    let that = this;
    window.onresize = function () {
      that.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
      that.$store.state.screenHeight = document.documentElement.clientHeight; //窗口高度
    };
    
  },
};
</script>

<style lang="css" src='@/assets/css/base.css'>
</style>
